<template>
    <v-sheet class="mb-5" color="transparent">
        <v-row class="mx-0">
            <v-sheet class="mr-3" color="primary" width="1" height="100" tile />
            <v-col>
                <div class="mb-3" v-text="value.years" />
                <div class="text-right">
                    <span class="text-h6 primary--text" v-text="value.name" />
                    <div class="text-h6 primary--text" v-text="value.description" />
                    <footer>
                        <div v-text="value.study" />
                        <div v-text="value.thesis" />
                        <div v-text="value.subject" />
                    </footer>
                </div>
            </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => ({
                years: '',
                name: '',
                description: '',
                study: '',
                thesis: '',
                subject: '',
            }),
        },
    },
};
</script>
